<template>
	<div class="newsletter">
		<h4>SUSCRIPCIÓN <b>NEWSLETTER</b></h4>
		<form
			class="form-row"
			id="newsletter-form"
			@submit.prevent="submit"
			:disbled="disbled"
		>
			<div class="col-4 form-group mb-2">
				<input
					class="form-control"
					type="text"
					placeholder="Nombre"
					v-model="form.name"
					:disbled="disbled"
				/>
			</div>
			<div class="col-8 col-sm-6 form-group mb-2">
				<input
					class="form-control"
					type="text"
					placeholder="Email"
					v-model="form.email"
					:disbled="disbled"
				/>
			</div>
			<div class="col form-group mb-2">
				<button
					class="btn btn-primary btn-block"
					type="submit"
					:disbled="disbled"
				>
					Enviar
				</button>
			</div>
		</form>
		<div class="newsletter-msg" v-if="message">
			<small>{{ message }}</small>
		</div>
	</div>
</template>

<script>
	import { subscribeNewsletter } from '../../Inmokey'
	export default {
		name: 'Newsletter',
		data() {
			return {
				form: {
					name: null,
					email: null
				},
				disbled: false,
				message: null
			}
		},
		methods: {
			submit() {
				this.message = null
				this.disbled = true
				subscribeNewsletter(this.form, r => {
					this.disbled = false
					this.form = { name: null, email: null }
					this.message = r.result ? 'Gracias por suscribirte.' : r.msg
				})
			}
		}
	}
</script>

<style></style>
